import { useSectionsRoutePrefixHook } from '@ingenico/react-section-utils';

export function useConfigurationSectionRoutePrefixHook(): string {
  const sectionsRoute = useSectionsRoutePrefixHook();
  // Use an api to enforce the typing because right now useSectionsRoutePrefixHook returns a Record<string, string>
  // and we need to have the MFE name as a key
  return sectionsRoute.configuration;
}
